import { Link } from "react-router-dom";
import type { CampanaSinWhatsapp } from "../../types";
import { useEsEquipoDeenex } from "../../../campana-nueva/hooks/useEsEquipoDeenex";

/** «A, B y C» */
const enLista = (xs: string[]) => (xs.length < 2 ? xs.join("") : `${xs.slice(0, -1).join(", ")} y ${xs[xs.length - 1]}`);

/**
 * Las campañas de Activa preparadas con todos sus grupos por mail: no aparecen para elegir porque al preparar sólo los
 * grupos de WhatsApp arman la campaña del oficial. Antes el paso decía «Todavía no hay campañas de Activa» aunque
 * estuvieran (HATSU, 26/10).
 */
export function AvisoSinWhatsapp({ campanas }: { campanas: CampanaSinWhatsapp[] }) {
  // Mensajes es del equipo de Deenex (`PaginaSoloEquipo`): a una persona del cliente se le dice a quién pedírselo.
  const equipo = useEsEquipoDeenex();
  if (!campanas.length) return null;
  return (
    <ul className="space-y-2" data-testid="campanas-sin-whatsapp">
      {campanas.map((c) => (
        <li key={c.segmentacionId} className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-900">
          «{c.nombre}» no aparece porque {c.grupos.length === 1 ? `su grupo, ${c.grupos[0]}, va` : `sus ${c.grupos.length} grupos (${enLista(c.grupos)}) van`} por mail.{" "}
          {equipo ? (
            <>
              Para mandarla por acá, en sus Mensajes pasá a WhatsApp los grupos que quieras, guardá y apretá «Preparar de nuevo».{" "}
              <Link to={`/activa/segmentaciones/${encodeURIComponent(c.segmentacionId)}/mensajes`} className="font-semibold underline whitespace-nowrap">Ir a sus Mensajes</Link>
            </>
          ) : (
            "Para mandarla por acá, pedile al equipo de Deenex que pase a WhatsApp los grupos que quieras."
          )}
        </li>
      ))}
    </ul>
  );
}
